import { MetricTest } from './metricTest';

declare var metricRange: Array<number>;
declare var metricMultiplier: number;

let metricTest = new MetricTest(metricRange, metricMultiplier);

metricTest.showImperialButton.addEventListener('click', (e:any) => {
    metricTest.onShowImperial(e);   
});

metricTest.newNumberButton.addEventListener('click', (e:any) => {
    metricTest.onRefresh(e);    
});

metricTest.onRefresh();